import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import LinkCell from "./LinkCell"
import LinkReel from "./LinkReel";

export default class LinkReelVertical extends LinkReel {

    constructor(scene: any, x: number, y: number, index: number, orientation: any) {
        super(scene, x, y, index, orientation);
        for (let i = 0; i < this.numOfLinkCellsPerReel + this.numOfExtraLinkCellsPerReel; i++) {
            this.linkCells[i] = new LinkCell(this.scene, this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, i, this);
            this.getContainer().add(this.linkCells[i].getContainer());
        }
    }

    public resetCellsPositions(): void {
        this.linkCells.forEach((linkCell, index) => {
            linkCell.getContainer().y = this.linkCellsPosition[index].y;
        });
    }

    public configureSpinTween(): void {
        this.resetFlagsAndCounters();

        this.spinProgress = this.scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height},
            paused: true,
            loop: -1,
            yoyo: false,
            duration: this.stepMs,
            onStart: () => {
                this.linkCells.forEach(linkCell => linkCell.stopAnimation());
            },
            onUpdate: () => {
                if (this.stopped) {
                    return;
                }

                const localOffset = (this.spinProgressValue.value + this.phaseOffsetPx) % this.cellSize.height;

                this.linkCells.forEach((linkCell) => {
                    // Position
                    linkCell.getContainer().y = this.linkCellsPosition[linkCell.getIndex()].y + localOffset;
                });
            },
            onLoop: () => {
                if (this.stopped) {
                    return;
                }

                this.virtualReelPosition = (this.virtualReelPosition + 1) % this.scene.linkGameArea.virtualGrid[this.index].length;
                this.scene.linkGameArea.increaseLoopCounter(this.index);

                this.reIndexCells();

                const elapsed = this.scene.time.now - this.t0;
                if (!this.canStop && elapsed >= this.preStopMs) {
                    this.canStop = true;
                }

                if (!this.canStop) { // Fake memo
                    const xmemo = this.scene.linkGameArea.virtualGrid[this.index][this.virtualReelPosition];
                    this.linkCells[this.lastLinkCellIndex].setCellInfo(xmemo);

                } else if (this.canStop) {
                    if (this.realMemoIndex === 0) { // Invisible cell
                        //TODO: adapt engine-side
                        const xmemo = this.scene.linkGameArea.virtualGrid[this.index][this.virtualReelPosition];
                        this.linkCells[this.lastLinkCellIndex].setCellInfo(xmemo);
                    } else if (this.realMemoIndex < this.lastLinkCellIndex) { // Visible cell, real memo
                        const realmemo = this.gameDataManager.getGrid()[this.index];
                        this.linkCells[this.lastLinkCellIndex].setCellInfo(realmemo);
                    } else if (this.realMemoIndex === this.lastLinkCellIndex) { // Invisible cell, fake memo with SCATTER and WILD check, stop spin
                        //TODO: adapt engine-side
                        const xmemo = this.scene.linkGameArea.virtualGrid[this.index][this.virtualReelPosition];
                        this.linkCells[this.lastLinkCellIndex].setCellInfo(xmemo);

                        this.spinProgress.stop();
                        this.bounce();
                    }
                    
                    this.realMemoIndex++;
                }
            }
        });
    }

    public bounce(): void {
        if (this.stopped) {
            return;
        }

        this.bounceTween1 = this.scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height * 0.75},
            yoyo: false,
            duration: this.spinAnimationDuration * 0.30,
            onStart: () => {
                this.stopped = true;
            },
            onUpdate: () => {
                this.linkCells.forEach((linkCell) => {
                    // Position
                    linkCell.getContainer().y = this.linkCellsPosition[linkCell.getIndex()].y + this.spinProgressValue.value;
                });
            },
            onComplete: () => {
                if(this.fixedLinkCell.getMemo() === 0)
                    this.scene.soundManager.play(ResourcesDispatcher.SOUNDS.SOUND_REELS_STOP);

                this.bounceTween2 = this.scene.tweens.add({
                    targets: this.spinProgressValue,
                    ease: "Power0",
                    value: { from: this.cellSize.height * 0.75, to: 0 },
                    yoyo: false,
                    duration: this.spinAnimationDuration * 2,
                    onUpdate: () => {
                        this.linkCells.forEach((linkCell) => {
                            // Position
                            linkCell.getContainer().y = this.linkCellsPosition[linkCell.getIndex()].y + this.spinProgressValue.value;
                        });
                    },
                    onComplete: () => {
                        this.scene.time.addEvent({
                            delay: 150,
                            callback: () => {
                                this.scene.linkGameArea.notifySpinCompleted(this.index);
                            },
                        });
                    }
                });
                if (this.spinMainButtonTween && this.spinMainButtonTween.isPlaying()) {
                    this.spinMainButtonTween.stop();
                    (window as any).isButtonSpinning = false;
                }
            }
        });
    }
}